import React from "react";
import { Table } from "antd";

const CustomNestedTable = ({ columns, data, isLoading }) => (
	<Table
		className="table row-border nowrap common-dataTable table-responsive"
		columns={columns}
		pagination={false}
		expandable={{
			expandedRowRender: (record) => {
				console.log(record);
				return (
					<Table
						className="table  nowrap common-dataTable table-responsive"
						pagination={false}
						style={{
							paddingLeft: "0px",
							margin: "0px",
						}}
						columns={record.table.columns}
						dataSource={record.table.data}
						scroll={{
							y: 1000,
						}}
						loading={isLoading}
					/>
				);
			},

			rowExpandable: (record) => record.restaurant_id !== "",
		}}
		dataSource={data}
	/>
);
export default CustomNestedTable;
